import { Component, Injector, OnInit } from '@angular/core';
import { AppConfiguration } from 'src/app/app-configuration';
import { ARTIFACT_KEY } from 'src/app/core/constants/artifacts-order.constants';
import { AppWizService } from 'src/app/core/services/app-wiz.service';
import { ArtifactBaseComponent } from '../artifact-base-component';
import { UploadService } from 'src/app/core/services/upload.service';
import { ARTIFACT_STATUS } from 'src/app/core/enums/artifact.enum';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/core/services/util.service';
import _ from 'lodash';

@Component({
  selector: 'app-file-upload-form',
  templateUrl: './file-upload-form.component.html',
  styleUrls: ['./file-upload-form.component.scss']
})
export class FileUploadFormComponent extends ArtifactBaseComponent implements OnInit {

  ARTIFACT_KEY = ARTIFACT_KEY;
  ARTIFACT_STATUS = ARTIFACT_STATUS;
  documents:any[] = [];
  fileUploadConfig:any;
  uploadFailed:boolean = false;
  constructor(
    private injector: Injector,
    public appConfig: AppConfiguration,
    public override appWizService : AppWizService,
    public override uploadService : UploadService,
    public utilService : UtilService,
    private router: Router,
  ) {
    super(injector)
  }

  setDefaultDocs(){
    let requestedDocuments = this.getDocTypes();
      this.documents = [];
      requestedDocuments?.map((docType:any)=>{
        docType.docType.subTypes?.map((subTypes:any)=>{
          this.documents.push({
            displayName: docType.docType.displayName,
            code: docType.docType.code,
            subTypes:[{
              documents: [],
              displayName: subTypes.displayName,
              code: subTypes.code,
              maxUpload: 5
            }]
          })
        })
      });
  }
  getDocTypes(){
    return this.artifact?.requestedDocuments;
  }

  initJsonData(){
    this.fileUploadConfig = _.clone(this.appConfig.fileUploadConfig);
    this.fileUploadConfig.maxFileCount = this.artifact.maxUpload || this.fileUploadConfig.maxFileCount;
    this.setDefaultDocs();
    this.jsonData = this.jsonData || { documents: [] };
  }
  /**
   * Set from the upload component's uploadFailure output. Held here rather than derived
   * from document status because the failed entry is removed from the document list.
   */
  onUploadFailure(hasFailure:boolean){
    this.uploadFailed = hasFailure;
    this.validateSection();
  }
  validateJsonData(){
    if(this.uploadFailed){
      this.artifact.sectionValid = false;
      return;
    }
    if(this.artifact.key == ARTIFACT_KEY.UPLOAD_MISC){
      this.artifact.sectionValid = true;
      return;
    }
    this.artifact.sectionValid = this.jsonData.documents?.length>0 || this.documents.length>0;
  }
  resetJsonData(){
    let unUsedDocuments = this.jsonData.documents;
    this.jsonData = { documents: [] };
    return unUsedDocuments;
  }

  override ngxOnChanges() {
    this.validateJsonData();
  }

  override processBeforeSubmit(){
    this.validateJsonData();
    if(this.jsonData.documents?.length){
      // this.jsonData.documents[0].updated = new Date();
    }
    this.artifact.documents = this.jsonData.documents; //this required for FileUploadArtifact only
  }
}
